"use client";

import React from "react";
import bgVideo from "../../assets/images/loader.mp4";
import { DPOS_FIGMA_ASSETS } from "./dposFigmaAssets";

export default function DposLoadingCard() {
  return (
    <div className="w-full overflow-hidden rounded-[24px] bg-white">
      <div className="relative flex min-h-[790px] items-center justify-center px-6 py-12">
        <div className="relative w-full max-w-[720px] aspect-[45/32]">
          <video
            src={bgVideo}
            autoPlay
            loop
            muted
            playsInline
            className="h-full w-full object-contain"
          />
          <img
            src={DPOS_FIGMA_ASSETS.loadingLogo}
            alt="80eight"
            className="absolute inset-0 m-auto h-auto w-[160px]"
          />
        </div>
      </div>
    </div>
  );
}
